import { render, staticRenderFns } from "./DocsCallout.vue?vue&type=template&id=6d893fb4&scoped=true"
import script from "./DocsCallout.vue?vue&type=script&lang=js"
export * from "./DocsCallout.vue?vue&type=script&lang=js"
import style0 from "./DocsCallout.vue?vue&type=style&index=0&id=6d893fb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d893fb4",
  null
  
)

export default component.exports